import { NAVBAR } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'navbar_27',
  type: NAVBAR,
  name: 'Navbar 27',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/navbar/navbar_27.png',
  rootContent: {
    type: contentTypes.NAVBAR,
    properties: {
      backgroundColor: {type: 'css', value: '#5A8DD6',editable: true},
      color: {type: 'css', value: '#c7dcf9',editable: true},
      padding: {type: 'css', value: '0.5rem 1rem'},
      fontSize: {type: 'css', value: 'small', editable: true},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '3.5rem'},
      navItemPadding: {type: 'custom', value: '0.5rem 2rem', editable: true},
      fontWeight: {type: 'css', value: 'normal'},
      navItemActiveTextColor: {type: 'custom', value: 'white'},
    },
    contents: []
  }
}
